import * as React from "react";
import {
  DateField,
  TextField,
  EditButton,
  TextInput,
  FunctionField,
  SelectInput,
  useRecordContext,
  ShowButton,
} from "react-admin";
import { Chip } from "@mui/material";
import { StateEnum } from "src/common/enum";
import { ShippingMethodEnum } from "src/common/enum/ShippingMethodEnum";
import { priceFormat } from "src/common/UtilFunctions";
import { DateRangeInput } from "src/components/input";
import { PriceRangeInput } from "src/components/input/PriceRangeInput";
import { Datagrid, List } from "src/enterprise/ra-rbac";
import { OrderStatusEnumIcons, OrderStatusEnum, OrderTypeEnum } from "src/common/enum";
import { getRoles } from 'src/common/AuthFunctions';

const listFilters = [
  <TextInput source="search" label="Search" alwaysOn />,
  <TextInput source="increment_id" label="Increment Id" />,
  <SelectInput source="status" choices={OrderStatusEnum} />,
  <PriceRangeInput source="total" label="Total" />,
  <DateRangeInput source="created_at" label="Created At" />,
  <SelectInput
    source="shipping_method.type"
    label="Shipping Method"
    choices={ShippingMethodEnum}
  />,
];

export const OrderList = (props) => {
  const filter = () => {
    return {};
  }

  return (
    <List {...props} filters={listFilters} queryOptions={{ cacheTime: 0 }} filter={filter()} sort={{ field: 'id', order: 'DESC' }}>
      <Datagrid>
        <TextField source="id" />
        <TextField source="increment_id" />
        <FunctionField
          label="Shiping"
          render={(record) =>
            record.shipping_address.first_name +
            " " +
            record.shipping_address.last_name
          }
        />
        <FunctionField
          label="Billing Name"
          render={(record) =>
            record.billing_address.first_name +
            " " +
            record.billing_address.last_name
          }
        />
        <FunctionField
          label="Billing State"
          render={(record) =>
            StateEnum.find((state) => state.id === record.billing_address.state)
              ?.name
          }
        />
        <FunctionField
          label="Total"
          sortBy="total"
          render={(record) => priceFormat(record.total, record.currency)}
        />

        <TextField source="items_total_quantity" label="Quantity" />

        <TextField source="created_at" label="Created At" />

        <FunctionField
          label="Type"
          sortBy="type"
          render={(record) => {
            return (
              <Chip label={OrderTypeEnum.find((x) => x.id === record.type)?.name}/>
            )
          }}
        />

        <FunctionField
          label="Status"
          sortBy="status"
          render={(record) => {
            let statusEnum = OrderStatusEnumIcons.find((status) => status.id === record.status);
            return (
              <Chip sx={{fontSize: "12px", padding: "6px 6px", height: "auto"}} label={statusEnum.name} color={statusEnum.color as any} icon={statusEnum.icon}/>
            )
          }}
        />
        <ShowButton />
      </Datagrid>
    </List>
  );
};
